import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOtherService } from 'api';



// Async thunk for fetching dashboard data
export const fetchOtherServiceData = createAsyncThunk(
  'otherService',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchOtherService();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dashboard data');
    }
  }
);

const otherServiceSlice = createSlice({
  name: 'otherService',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOtherServiceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOtherServiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOtherServiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = otherServiceSlice.actions;
export default otherServiceSlice.reducer;
